import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import i18n from 'i18n';

class Content extends React.Component {
  scrollToAnchor = anchorName => {
    if (anchorName) {
      let anchorElement = document.getElementById(anchorName);
      if (anchorElement) {
        anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  };

  render() {
    const { className } = this.props;

    return (
      <div className={className}>
        <ul className="anchor-ul">
          {i18n
            .t('faq:content:links', { returnObjects: true })
            .map((link, i) => (
              <li key={i}>
                <a onClick={() => this.scrollToAnchor(`link-${i}`)}>{link}</a>
              </li>
            ))}
        </ul>
      </div>
    );
  }
}

const commonStyle = css`
  ul.anchor-ul {
    list-style: none;
    line-height: 1 !important;
    padding: 0;
    margin: 0;

    li {
      color: ${Colors.orange1};

      a {
        cursor: pointer;

        &:hover,
        &:active {
          color: ${Colors.orange3};
          cursor: pointer;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  ul.anchor-ul {
    ${FontStyles.text7};

    li {
      margin-bottom: 24px;
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  ul.anchor-ul {
    ${FontStyles.text5};

    li {
      margin-bottom: 26px;
    }
  }
`;

export default applyStyles(Content)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Faq/components/Content.js